import { RefreshCw } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { FormSection } from '@nucleus-commerce/admin-kit/forms';
import { Button } from '@nucleus-commerce/ui/components/button';

import { SECTION_ANCHORS } from '@/shared/navigation/section-anchors';

import { useReindexSearch } from '../hooks/use-reindex-search';

/** Explains automatic indexing and offers the manual rebuild. */
export function SearchSettingsCard({ storeId }: { storeId: string }) {
  const { t } = useTranslation('stores');
  const reindex = useReindexSearch(storeId);
  return (
    <FormSection
      id={SECTION_ANCHORS.productSearch}
      title={t('search.title')}
      description={t('search.description')}
    >
      <Button
        type="button"
        variant="outline"
        size="sm"
        disabled={reindex.isPending}
        onClick={() => reindex.mutate()}
      >
        <RefreshCw aria-hidden className={reindex.isPending ? 'animate-spin' : undefined} />
        {reindex.isPending ? t('search.rebuilding') : t('search.rebuild')}
      </Button>
    </FormSection>
  );
}
